import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const SpecialOfferStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
    selectStyle :  {
        border: '1px solid',
        padding: '16px',
        fontSize: '1rem',
        minWidth: 0,
        background: styleColors.white,
        fontStyle: 'normal',
        fontFamily: "'Metropolis', 'Helvetica', 'Arial', sans-serif",
        fontWeight: 500,
        lineHeight: 'normal',
        borderColor: styleColors.black,
        borderRadius: '0.1875rem',
    },
    labelWrapper : {
        gap: '8px',
        display: 'flex',
        flexDirection: 'column',
    },
    labelText : {
        color: styleColors.black,
        fontSize: '0.9375rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
    }
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepSpecialOffer/specialoffer.styles.ts